import { getYaNative } from '@yanolja-org/ya-native';

/**
 * Braze 클라이언트 로그를 전송하기 위한 객체
 * Braze는 앱에서만 전송된다.
 * @link {https://jira.yanolja.in/browse/YAFE-184}
 */
const _BrazeWrapper = {
  /**
   * 정의된 커스텀 이벤트를 전송하는 메소드
   * @link {https://docs.google.com/spreadsheets/d/1iJdrTz1HPMxbPx7Au9SSv6S6DZas32ZbnFzEy0WtbMk/edit#gid=1308376500}
   * @param eventName
   * @param data
   */
  sendCustomEvent(eventName: string, data?: Record<string, unknown>): void {
    const _yaNative = typeof window === 'undefined' ? null : getYaNative();
    if (!_yaNative?.isEnabled) return;
    // 야놀자 앱에서 braze 로그 전송
    _yaNative.braze({ eventName, ...data }, () => null);
  },
};

export default _BrazeWrapper;
